import Nullstack from 'nullstack';
export default function IconBusStop({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-bus-stop",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "3",
    width: "4",
    height: "6",
    rx: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "18",
    cy: "17",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M10 5h7c2.761 0 5 3.134 5 7v5h-2"
  }), "   ", Nullstack.element("path", {
    d: "M16 17h-8"
  }), "   ", Nullstack.element("path", {
    d: "M16 5l1.5 7h4.5"
  }), "   ", Nullstack.element("path", {
    d: "M9.5 10h7.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 5v5"
  }), "   ", Nullstack.element("path", {
    d: "M5 9v11"
  }), " ");
}